// src/hooks/useSmsReplyUnread.js
//
// Thin consumer of smsReplyStore (features/unified-replies/). Returns
// { units, perTeam: [{teamId, name, count, newestAtMs}], settled }.
//
// units counts TEAMS with unread SMS replies, not individual replies
// (BA decision D-2), so it can be added directly to the chat unread
// count everywhere the combined badge number is needed.

import { useCallback, useSyncExternalStore } from 'react';
import { useAuth } from '@/context/AuthContext';
import { subscribeSmsReplyStore, getSmsReplySnapshot } from './smsReplyStore';

export default function useSmsReplyUnread() {
  const { firebaseUser } = useAuth();
  const uid = firebaseUser?.uid || null;

  const subscribe = useCallback(
    (cb) => subscribeSmsReplyStore(uid, cb),
    [uid],
  );

  return useSyncExternalStore(subscribe, getSmsReplySnapshot, getSmsReplySnapshot);
}
